import React, { useEffect, useRef } from 'react'
import animation from '../../../images/renshin-animation.webm'

function LoaderAnimation() {
    const video = useRef(null)

    useEffect(() => {
        const player = video.current

        if (player) {
            const promise = player.play()

            if (promise !== undefined) {
                promise.catch(() => {})
            }
        }
    }, [])

    return (
        <video ref={video} autoPlay muted playsInline preload='auto' data-keepplaying='data-keepplaying'>
            <source src={animation} type='video/webm' />
        </video>
    )
}

export default LoaderAnimation
